import MasterAdminApp from '@/src/masterAdminApp'
import MasterAdminSites from '@/pages/masterAdmin/Sites/index.vue'
import MasterAdminPosts from '@/pages/masterAdmin/Posts/index.vue'
import MasterAdminCopyChecks from '@/pages/masterAdmin/CopyChecks/index.vue'
import MasterAdminOrders from '@/pages/masterAdmin/Orders/index.vue'
import MasterAdminOrderReports from '@/pages/masterAdmin/OrderReports/index.vue'
import MasterAdminBulkRegistration from '@/pages/masterAdmin/BulkRegistration/index.vue'
import MasterAdminUserAuths from '@/pages/masterAdmin/UserAuths/index.vue'
import MasterAdminUserAuthEdit from '@/pages/masterAdmin/UserAuths/edit.vue'
import MasterAdminAuditLogs from '@/pages/masterAdmin/AuditLogs/index.vue'
import MasterAdminClientInspectionManagement from '@/pages/masterAdmin/ClientInspectionManagement/index.vue'
import MasterAdminProfile from '@/pages/masterAdmin/Profiles/index.vue'
import MasterAdminEmail from '@/pages/masterAdmin/Emails/index.vue'
import MasterAdminSitesSidebar from '@/components/sidebars/masterAdmin/SitesSidebar'
import MasterAdminUsersSidebar from '@/components/sidebars/masterAdmin/UsersSidebar'

export const masterAdminSitesPathName = 'masterAdminSites'
export const masterAdminPostsPathName = 'masterAdminPosts'
export const masterAdminCopyChecksPathName = 'masterAdminCopyChecks'
export const masterAdminOrdersPathName = 'masterAdminOrders'
export const masterAdminClientInspectionManagementPathName =
  'masterAdminClientInspectionManagement'
export const masterAdminBulkRegistrationPathName = 'masterAdminBulkRegistration'
export const masterAdminOrderReportsPathName = 'masterAdminOrderReports'
export const masterAdminUsersPathName = 'masterAdminUsers'
export const masterAdminUserAuthsPathName = 'masterAdminUserAuths'
export const masterAdminUserAuthEditPathName = 'masterAdminUserAuthEdit'
export const masterAdminAuditLogsPathName = 'masterAdminAuditLogs'
export const masterAdminProfilesPathName = 'masterAdminProfiles'
export const masterAdminEmailsPathName = 'masterAdminEmails'

export default {
  path: '/master_admin',
  component: MasterAdminApp,
  meta: { requiresAuth: true },
  children: [
    {
      path: '',
      redirect: { name: masterAdminSitesPathName }
    },
    {
      path: 'sites',
      name: masterAdminSitesPathName,
      components: {
        default: MasterAdminSites,
        subSidebar: MasterAdminSitesSidebar
      },
      children: [
        {
          path: ':siteKey/posts',
          name: masterAdminPostsPathName,
          component: MasterAdminPosts
        },
        {
          path: ':siteKey/posts/copy_checks',
          name: masterAdminCopyChecksPathName,
          component: MasterAdminCopyChecks
        },
        {
          path: ':siteKey/orders',
          name: masterAdminOrdersPathName,
          component: MasterAdminOrders
        },
        {
          path: ':siteKey/orders/client_inspection_management',
          name: masterAdminClientInspectionManagementPathName,
          component: MasterAdminClientInspectionManagement
        },
        {
          path: ':siteKey/orders/bulk_registration',
          name: masterAdminBulkRegistrationPathName,
          component: MasterAdminBulkRegistration
        }
      ]
    },
    {
      path: 'orders/reports',
      name: masterAdminOrderReportsPathName,
      components: {
        default: MasterAdminOrderReports
      }
    },
    {
      path: 'users',
      name: masterAdminUsersPathName,
      redirect: 'users/user_auths'
    },
    {
      path: 'users/user_auths',
      name: masterAdminUserAuthsPathName,
      components: {
        default: MasterAdminUserAuths,
        subSidebar: MasterAdminUsersSidebar
      }
    },
    {
      path: 'users/user_auths/:id/edit',
      name: masterAdminUserAuthEditPathName,
      components: {
        default: MasterAdminUserAuthEdit,
        subSidebar: MasterAdminUsersSidebar
      }
    },
    {
      path: 'users/audit_logs',
      name: masterAdminAuditLogsPathName,
      components: {
        default: MasterAdminAuditLogs,
        subSidebar: MasterAdminUsersSidebar
      }
    },
    {
      path: 'profiles',
      name: masterAdminProfilesPathName,
      components: {
        default: MasterAdminProfile
      }
    },
    {
      path: 'emails',
      name: masterAdminEmailsPathName,
      components: {
        default: MasterAdminEmail
      }
    }
  ]
}
